'use client';

import { Position, Handle } from '@xyflow/react';
import { Text } from '@terra/ui-design-system';
import { Box, VStack } from '@terra/ui-styled-system';
import type { ComponentType, ReactNode } from 'react';

type BaseGraphNodeProps = {
  id: string;
  name: string;
  nodeColor: string;
  NodeIcon: ComponentType<{ size: number; color: string; strokeWidth: number }>;
  cursor?: string;
  iconBadge?: ReactNode;
  aboveName?: ReactNode;
  children?: ReactNode;
};

export function BaseGraphNode({
  id,
  name,
  nodeColor,
  NodeIcon,
  cursor = 'pointer',
  iconBadge,
  aboveName,
  children,
}: BaseGraphNodeProps) {
  return (
    <Box id={id} position="relative">
      <VStack
        gap={0}
        alignItems="center"
        transition="transform 0.15s ease"
        _hover={{ transform: 'scale(1.05)' }}
        cursor={cursor}
      >
        <Box
          w="48px"
          h="48px"
          borderRadius="full"
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{ backgroundColor: nodeColor }}
          mb={aboveName ? 2 : 3}
          position="relative"
        >
          <NodeIcon size={18} color="white" strokeWidth={2} />
          {iconBadge}
        </Box>

        {aboveName}

        <Box mb={children ? 1.5 : 0} position="relative">
          <Handle
            type="target"
            position={Position.Left}
            style={{ opacity: 0 }}
          />
          <Text fontSize="sm" fontWeight={500} color="fg.default">
            {name}
          </Text>
          <Handle
            type="source"
            position={Position.Right}
            style={{ opacity: 0 }}
          />
        </Box>

        {children}
      </VStack>
    </Box>
  );
}
